"use client";

import { SignupFormContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { SignUpTitle } from "@faire/retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import { useSignUpRequest } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { useSaveRequestAndGoToNextStep } from "@faire/retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import {
  StoreTypeForm,
  StoreTypeData,
  useSchema,
} from "@faire/retailer-visitor-shared/views/SignUp/store-type-s1/__internal__/StoreTypeForm";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { StoreType } from "@faire/web--source/common/StoreType";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Formik } from "formik";
import React from "react";

export const StoreTypeStep: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const { saveAndGoToNextStep } = useSaveRequestAndGoToNextStep(
    Step.STORE_TYPE_S1
  );
  const [initialValue] = useSignUpRequest(["style_quiz"]);
  const schema = useSchema();

  const onNext = async (values: StoreTypeData) => {
    const styleQuiz = values.style_quiz;
    if (styleQuiz && styleQuiz?.store_type !== StoreType.OTHER) {
      styleQuiz.other_store_type = undefined;
    }

    saveAndGoToNextStep({ style_quiz: styleQuiz });
  };

  return (
    <SignupFormContainer>
      <SignUpTitle
        title={strictLocalize({
          defaultMessage: "Which of these best describes your store?",
          description: {
            img: "https://cdn.faire.com/fastly/c93dfaa35292c51ce8b04b8178b7613198150937dde307064b573a15c5ac654c.png",
            text: "Title asking the user to select a type of store that best describes their business",
          },
        })}
      />
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="We use this info to tailor your product recommendations."
          description={{
            img: "https://cdn.faire.com/fastly/b18dc908ac090b028642a6960e434f15ab813c7aa1259a1ea3bdde29fcf192a6.png",
            text: "Description explaining how the store type will be used to tailor product recommendations",
          }}
        />
      </Typography>
      <Spacer height="4x" />
      <Formik
        initialValues={initialValue}
        validationSchema={schema}
        onSubmit={onNext}
      >
        <StoreTypeForm />
      </Formik>
    </SignupFormContainer>
  );
};
